import { Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Box, Typography } from '@mui/material'

export function ChatPlaceholder() {
  useLingui()
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'text.secondary',
        backgroundColor: 'white',
      }}
    >
      <Typography variant="h6">
        <Trans>Select a conversation</Trans>
      </Typography>
    </Box>
  )
}
